module.exports = window.wp.blob;